import { Field } from "@qid/field";
import { Participant } from "../model/participant";
import { ShareStatus } from "../enum/share-status.enum";
import { CollectionTemplateAgreement } from "../../collection-template";


export class UpdateShareDto {

  otherFields?: Field[];

  masterKeyString?: string;

  template?: string;

  scan?: string;

  scanAndShareDurationSeconds?: number;

  agreements?: CollectionTemplateAgreement[];

  participants?: Participant[];

  status?: ShareStatus;

  updateRemark?: string;

  checkInData?: any

  changeLastUpdateTime?: boolean = true;

  isPublicJoin?: boolean;

  constructor() {

  }

}
